module.exports = __webpack_public_path__ + "img/ad.0c408f7b.png";